//# sourceMappingURL=dropdown.mjs.map
/// <reference types="./dropdown.d.mts" />
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $angle from "../../../../sketch/sketch/css/angle.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { percent, px, vh } from "../../../../sketch/sketch/css/length.mjs";
import * as $transform from "../../../../sketch/sketch/css/transform.mjs";
import * as $h from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../../ds/colors.mjs";
import * as $shadows from "../../../ds/css/shadows.mjs";
import * as $text from "../../../ds/typography/text.mjs";
import { toList, prepend as listPrepend } from "../../../gleam.mjs";

export function full_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.position("relative"),
      $css.width(percent(100)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

function optional_class(class$) {
  let _pipe = class$;
  let _pipe$1 = $option.map(_pipe, $css.compose);
  return $option.lazy_unwrap(_pipe$1, $css.none);
}

export function wrapper(disabled, extra_class, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.align_items("start"),
      $css.gap(px(6)),
      $css.width(percent(100)),
      $css.opacity(
        (() => {
          if (disabled) {
            return 0.5;
          } else {
            return 1.0;
          }
        })(),
      ),
      optional_class(extra_class),
    ]),
  );
  return $h.label(_pipe, attrs, children);
}

function dropdown_base() {
  return $css.class$(
    toList([
      $css.compose($text.md($text.medium)),
      $css.appearance("none"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("space-between"),
      $css.background($colors.light.text_white),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius(px(8)),
      $css.gap(px(8)),
      $css.padding_("10px 14px"),
      $css.cursor("pointer"),
      $css.position("relative"),
      $css.transition("opacity .3s, box-shadow .3s"),
      $css.white_space("nowrap"),
      $css.disabled(toList([$css.cursor("auto"), $css.user_select("text")])),
      $css.selector("[data-small=true]", toList([$css.padding_("4px 8px")])),
      $css.selector(
        "[data-opened=true] .dropdown-arrow",
        toList([$css.transform(toList([$transform.rotate($angle.turn(0.5))]))]),
      ),
    ]),
  );
}

export function standard(input_class, attrs, children) {
  let _pipe = $css.class$(
    toList([$css.compose(dropdown_base()), optional_class(input_class)]),
  );
  return $h.button(_pipe, attrs, children);
}

export function disabled(input_class, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(dropdown_base()),
      $css.opacity(0.6),
      optional_class(input_class),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function active(input_class, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.box_shadow("0px 0px 0px 4px " + $colors.light.grey_100),
      $css.compose(dropdown_base()),
      optional_class(input_class),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

export function text_icon_wrapper(active, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.min_width(px(0)),
      (() => {
        if (active) {
          return $css.none();
        } else {
          return $css.color($colors.light.grey_800);
        }
      })(),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function label_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.overflow("hidden"),
      $css.text_overflow("ellipsis"),
      $css.white_space("nowrap"),
      $css.min_width(px(0)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function choice_icon_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function full_icon_wrapper(child) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.width(px(20)),
      $css.height(px(20)),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([child]));
}

export function children_wrapper(panel_class, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.background($colors.light.text_white),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.box_shadow($shadows.m()),
      $css.border_radius(px(8)),
      $css.max_height(vh(30)),
      $css.min_width_("fit-content"),
      $css.overflow("auto"),
      $css.z_index(100_000_000_000),
      $css.compose(panel_class),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function search_wrapper(attrs, children) {
  let _pipe = $css.class$(toList([$css.padding(px(6))]));
  return $h.div(_pipe, attrs, children);
}

export function no_choice(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.grey_600),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.padding(px(24)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function choice_wrapper(class$, highlighted, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.color($colors.light.text_display),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("space-between"),
      $css.padding_("10px 14px"),
      $css.gap(px(10)),
      $css.cursor("pointer"),
      $css.background(
        (() => {
          if (highlighted) {
            return $colors.light.grey_100;
          } else {
            return $colors.light.transparent;
          }
        })(),
      ),
      $css.hover(toList([$css.background($colors.light.grey_200)])),
      optional_class(class$),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function icon_wrapper(attrs, children) {
  return $h.div(
    $css.class$(toList([$css.width(px(20)), $css.height(px(20))])),
    attrs,
    children,
  );
}

export function arrow_wrapper(attrs, children) {
  let attrs$1 = listPrepend($a.class$("dropdown-arrow"), attrs);
  let _pipe = $css.class$(
    toList([
      $css.width(px(20)),
      $css.height(px(20)),
      $css.transition("transform .2s"),
    ]),
  );
  return $h.div(_pipe, attrs$1, children);
}

export function subtitle_wrapper(attrs, children) {
  return $h.div($text.xs($text.regular), attrs, children);
}

export function section_wrapper(class$, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.color($colors.light.grey_800),
      $css.position("sticky"),
      $css.top(px(0)),
      $css.padding(px(10)),
      $css.background($colors.light.text_white),
      $css.border_bottom("1px solid " + $colors.light.grey_200),
      optional_class(class$),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}
